export default function Tag({ children, variant = 'default', className = '' }) {
  const variants = {
    default: 'bg-[#F1F5F9] border-[#E2E8F0] text-[#475569]',
    gold: 'bg-[#F0FDF4] border-[#1B5E20] text-[#1B5E20]',
    green: 'bg-[#DCFCE7] border-[#16A34A] text-[#16A34A]',
    charcoal: 'bg-[#0F172A] border-[#0F172A] text-white',
    slate: 'bg-[#F1F5F9] border-[#475569] text-[#475569]',
  }

  return (
    <span className={`inline-flex items-center px-3.5 py-1.5 text-xs font-medium tracking-wide uppercase rounded-full border ${variants[variant]} ${className}`}>
      {children}
    </span>
  )
}
